import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { SessionTimeoutTestIds } from '@layout/session-timeout/components/session-timeout/session-timeout.test-ids';
import { CountdownComponent } from '@layout/session-timeout/components/countdown/countdown.component';
import { TranslatePipe } from '@ngx-translate/core';
import { timer } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DialogComponent, DialogHeaderComponent, injectDialogReference, RegularButtonComponent } from '@kaseya-design-components';

@Component({
  selector: 'itc-session-timeout',
  templateUrl: 'session-timeout.component.html',
  styleUrl: 'session-timeout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CountdownComponent, TranslatePipe, RegularButtonComponent, DialogHeaderComponent, DialogComponent],
})
export class SessionTimeoutComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly autoLogoutDelayMs = 120 * 1000;
  private readonly dialogReference = injectDialogReference();

  readonly testIds = SessionTimeoutTestIds;

  ngOnInit(): void {
    timer(this.autoLogoutDelayMs)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.logOut());
  }

  resumeSession(): void {
    this.dialogReference.confirm();
  }

  logOut(): void {
    this.dialogReference.dismiss();
  }

  getLogoutDelayInSeconds(): number {
    return this.autoLogoutDelayMs / 1000;
  }
}
